module.exports = __webpack_public_path__ + "static/media/crossword-frame.9bfdb026.png";